import {
  Button,
} from 'web-components';
import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Layout = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
`;

export const Main = styled(Flex).attrs({
  column: true,
})`
  height: 100%;
  flex: 1 1 calc(100% - 230px);
`;

export const Content = styled(Flex).attrs({
  row: true,
})`
  width: 100%;
  flex: 1 1 calc(100% - 64px);
  overflow: hidden auto;
`;

export const Announcement = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
})`
  color: white;
  background: #E45757;
  width: 100%;
  padding: 12px;
`;

export const AnnouncementTitle = styled.h3`
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
`;

export const AnnouncementDescription = styled.span`
  color: white;
`;

export const AnnouncementDismiss = styled(Button).attrs({
  appereance: 'link',
})`
  color: white;
  border: 1px solid white;
  background: transparent;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
  margin: auto;
  width: 100px;
  height: 38px;

  &:hover {
    color: white;
    text-decoration: none;
  }
`;
